module.exports = __webpack_public_path__ + "img/01.ab019d6e.gif";